import { render, staticRenderFns } from "./Icon2D.vue?vue&type=template&id=f204e890&scoped=true&"
import script from "./Icon2D.vue?vue&type=script&lang=js&"
export * from "./Icon2D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f204e890",
  null
  
)

export default component.exports